import React from "react"
import { SwanHead, SWAN_STYLE_KEY_MAP } from "@vp/swan"
import { BookendsMetaTag, BOOKEND_TYPES } from "@vp/esi-bookends"

const styleKeysToLoad = [
  SWAN_STYLE_KEY_MAP.core,
  SWAN_STYLE_KEY_MAP.grid,
  SWAN_STYLE_KEY_MAP.icon,
  SWAN_STYLE_KEY_MAP.button,
  SWAN_STYLE_KEY_MAP.carousel,
  SWAN_STYLE_KEY_MAP.standardTile,
  SWAN_STYLE_KEY_MAP.accordion,
  SWAN_STYLE_KEY_MAP.toggleSwitch,
  SWAN_STYLE_KEY_MAP.popover,
  SWAN_STYLE_KEY_MAP.pricing,
  SWAN_STYLE_KEY_MAP.hidden,
  SWAN_STYLE_KEY_MAP.visible,
  SWAN_STYLE_KEY_MAP.utility,
  SWAN_STYLE_KEY_MAP.modalDialog,
  SWAN_STYLE_KEY_MAP.listbox,
]

export const Head = ({ pageContext }) => (
  <>
    <SwanHead swanLocale={pageContext.node_locale} swanTenant={pageContext.tenant} key="swan-head" styleSheetKeys={styleKeysToLoad} />
    <BookendsMetaTag
      locale={pageContext.node_locale}
      tenant={pageContext.tenant}
      headerType={BOOKEND_TYPES.FULL}
      footerType={BOOKEND_TYPES.FULL}
      inlineCriticalCss={true}
    />
  </>
)
